import React, { FC, useEffect, useState, useRef, Ref } from 'react';
import { LabelValidator } from './label-validador';
import { InputProps } from './props';
import { Container, StyledLabel } from './styles';
import styled from 'styled-components';
import { CurrencyInput } from '../currency';

export const StyledInput = styled(CurrencyInput)<InputProps & any>`
    padding: 17px 13px 1px 10px;
    width: 100%;
    border: none;
    outline: none;
    height: 44px;
    box-sizing: border-box;
    box-shadow: none;
    border: 1px #bfbfbf solid;
    color: #444;
    background: #fff;
    border-radius: 4px;
    font-size: 15px;

    ${(props) =>
        !!props.isValid
            ? !props.isValid?.valid
                ? `border: 1px #b00020 solid;`
                : `border: 1px #33b216 solid;`
            : null}
`;

export const InputCurrency: FC<InputProps> = ({
    label,
    value,
    color = '#47516f',
    isValid,
    style,
    onChange,
    ...rest
}) => {
    const ref: Ref<HTMLInputElement> = useRef(null);
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(true);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <StyledInput
                decimalSeparator=','
                thousandSeparator='.'
                precision={2}
                {...rest}
                isValid={isValid}
                value={text}
                ref={ref}
                onChangeEvent={(__: any, _: any, floatValue: any) => {
                    setText(floatValue), onChange?.(floatValue);
                }}
                placeholder=''
            />
            <StyledLabel active={focused || text !== ''}>{label}</StyledLabel>
            <LabelValidator isValid={isValid} />
        </Container>
    );
};
